import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';

import { isLoading, load, get } from '../reducers/meetings';

import HorseRacingResultsForDate from '../components/HorseRacingResultsForDate';
import { getYesterdaysDate, isoDate } from 'utils/LocalDateTimeHelper';

const REFRESH_INTERVAL_MILLIS = 15000;


function convertDate(date)
{
  if(date == 'yesterday') {
    date = getYesterdaysDate("YYYY-MM-DD");
  }
  return date;
}

@standardAsyncConnect([
  {
    dispatch: ({params: {date = isoDate()}}) => load(convertDate(date)),
    preventResolve: ({state, params: {date = isoDate()}}) => isLoading(state, convertDate(date)),
    refreshInterval: REFRESH_INTERVAL_MILLIS,
    state: state => ({meetingsByDate: get(state)})
  }
])
@catchLifeCycleErrors
export default class HorseRacingResultsForDateContainer extends Component {
  static propTypes = {
    // supplied by react-router via @connect
    routes: PropTypes.array.isRequired,
    params: PropTypes.shape({
      date: PropTypes.string
    }),
    meetingsByDate: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired
  };

  render() {
    return (
      <HorseRacingResultsForDate
        routes={this.props.routes}
        date={convertDate(this.props.params.date) || isoDate()}
        meetingsByDate={this.props.meetingsByDate}
        raceType="Racing"/>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingResultsForDateContainer.js